import type SignImage from "../app/objects/sign_image"
import type SignText from "../app/objects/sign_text"
import { type SignObject } from "../app/sign_objects"

export function isImage(state: SignObjectState): state is SignImageState {
  return typeof (state as SignImageState).id === "number"
}

export function isText(state: SignObjectState): state is SignTextState {
  return typeof (state as SignTextState).text === "string"
}

export function isImageObj(obj: SignObject): obj is SignImage {
  return typeof (obj.state as SignTextState).id === "number"
}

export function isTextObj(obj: SignObject): obj is SignText {
  return typeof (obj.state as SignTextState).text === "string"
}
